<template>
  <div class="page-bank-sure">
    <p class="text-1">{{ $t('withdraw.pleaseCheck') }}</p>
    <p class="text-2">
      {{ $t('withdraw.warningNote') }}
    </p>
    <FawryBankInfo />
    <div class="btn-warp">
      <x-button class="btn-cancel" @click.native="goBack">{{ $t('withdraw.cancel') }}</x-button>
      <x-button class="btn-done" type="primary" @click.native="sure">{{ $t('withdraw.sure') }}</x-button>
    </div>
  </div>
</template>
<script>
import { XButton } from 'vux'
import FawryBankInfo from './FawryBankInfo.vue'
import state from '@/state.js'
import localStorage from '@/utils/localStorage/index.js'
import base64ToFile from '@/utils/base64ToFile.js'
import httpService from '@/api/config'
import upload from '@/api/upload'
import { ERROR_MAP, WITHDRAW_TYPE } from '@/utils/constants'
import { myMixins } from '@/mixins/myMixins.js'
export default {
  name: 'BankSure',
  components: {
    FawryBankInfo,
    XButton
  },
  mixins: [myMixins],
  data() {
    return {
      state,
      signatureFile: null,
      withdrawing: false
    }
  },
  methods: {
    getParam() {
      let bankInfo = JSON.parse(JSON.stringify(state.bankInfo))
      bankInfo.type = WITHDRAW_TYPE.FAWRY
      bankInfo.redeem_goods_id = this.state.redeemGoodsId
      // console.log(bankInfo)
      return bankInfo

    },
    withdrawByServe() {
      httpService(
        {
          url: '/v1/withdraw'
        },
        this.getParam()
      )
        .then(data => {
          let result = data.data
          if (result.withdraw_time) {
            this.state.withdrawalStatus = this.$t('withdraw.reviewing')
            this.state.withdrawalType = WITHDRAW_TYPE.FAWRY
            localStorage.set(this.state.userId + '_bankInfo', this.state.bankInfo)
            ta.track('t000_cash_exchange_suc', {
              user_id: this.state.userId,
              stats: this.getTaWithdrawType(),
              entrance: 1
            })
            this.$router.push('/result')
          }
        })
        .catch(data => {
          this.withdrawing = false
          this.$toast.textShow(ERROR_MAP[data.error_code ? data.error_code : '1'])
        })
    },
    uploadSignatureFile() {
      upload(this.signatureFile)
        .then(data => {
          this.state.bankInfo.signature = data
          this.withdrawByServe()
        })
        .catch(data => {
          this.withdrawing = false
          this.$toast.textShow(this.$t('withdraw.uploadError'))
        })
    },
    sure() {
      if (this.withdrawing === true) {
        return false
      }
      this.withdrawing = true
      if (this.signatureFile) {
        this.uploadSignatureFile()
      } else {
        this.withdrawByServe()
      }
    },
    goBack() {
      this.$router.back()
    }
  },
  mounted() {
    let signature = this.state.bankInfo.signature
    if (signature.indexOf('http') < 0) {
      this.signatureFile = base64ToFile(signature)
    }
  }
}
</script>
<style lang="scss">
.page-bank-sure {
  padding: 32px 20px 40px;

  .text-1 {
    margin-bottom: 4px;

    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
    text-align: center;
  }

  .text-2 {
    margin-bottom: 30px;

    font-size: 13px;
    line-height: 16px;
    text-align: center;

    color: #ff5d88;
  }

  .btn-warp {
    display: flex;

    margin-top: 20px;

    .weui-btn_default {
      margin-right: 8px;

      color: #3c3c43;
      background: #fff;
    }

    .weui-btn_primary {
      margin-top: 0;
      margin-left: 8px;
    }
  }
}
</style>
